import { css } from 'linaria';
import PropTypes from 'prop-types';
const barWrapper = "b1ke8nt6";
export const ProgressPill = ({
  total = 100,
  current = 0
}) => {
  const barTranslate = 100 - (current + 1) / total * 100;
  return <div className={barWrapper}>
      <div style={{
      transform: `translateX(-${barTranslate}%)`
    }} />
    </div>;
};
ProgressPill.propTypes = {
  // Progress Pill Props

  /**
   * total
   */
  total: PropTypes.number,

  /**
   * current value
   */
  current: PropTypes.number
};

require("./progress-pill.linaria.module.css!=!../../../node_modules/linaria/lib/outputCssLoader.js?cacheProvider=!./progress-pill.js");